import service from '@/services';

const buscarRelatorioEndosso = async (
  paginaAtual,
  itensPerPage,
  searchQuery,
) => {
  try {
    const result = await service.getFilterPagination(
      `endosso`,
      {
        page: paginaAtual,
        limit: itensPerPage,
        search: searchQuery,
      },
      'relatorio',
    );
    return result;
  } catch (err) {
    return {
      error: 'Não foi possível carregar os dados. Tente novamente mais tarde.',
    };
  }
};

const endossoVeiculoSemFipe = async () => {
  try {
    const result = await service.get('endosso/validar', '');
    return result;
  } catch (err) {
    return {
      error: 'Não foi possível carregar os dados. Tente novamente mais tarde.',
    };
  }
};

const baixarRelatorioEndosso = async () => {
  try {
    const result = await service.getDocumentBlob('endosso/relatorio/excel', {});
    const url = window.URL.createObjectURL(new Blob([result.data]));
    const link = document.createElement('a');
    link.href = url;
    link.setAttribute('download', 'endosso.xlsx');
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    return result;
  } catch (err) {
    throw err;
  }
};

export default {
  buscarRelatorioEndosso,
  baixarRelatorioEndosso,
  endossoVeiculoSemFipe,
};
